/**
 * Add a new client
 *
 * @param client
 * @returns {function(*)}
 */
import * as types from "../constants/actionTypes";
import {addNotification as notify} from 'reapop';
import * as clientActions from "../graphql/actions/client";
import l10n from "../l10n/localization";
import * as selected from "./selected";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";




export function fetchClients(force = false) {
    return dispatch => {
        dispatch(loading());
        clientActions.getClients(
            function (response) {
                dispatch(receiveClients(response.data.clients));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            force
        );
    };
}

export function add(client, selectNewItem = false) {
    delete client.item;
    delete client.selectNewItem;
    
    return dispatch => {
        dispatch(loading());
        dispatch(saving(client));
        clientActions.add(
            function (response) {
                if (selectNewItem === true) {
                    dispatch(selected.selectedClient(response.data.createClient))
                }
                dispatch(saved(response.data.createClient));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedClient(response.data.createClient));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            client
        );
    };
}


export function edit(client) {
    let id = client.id;
    delete client.id;
    delete client.__typename;
    delete client.currencyName;
    delete client.item;
    delete client.selectNewItem;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(client));
        clientActions.edit(
            function (response) {
                dispatch(saved(response.data.editClient));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            client
        );
    };
}

export function deleteClient(clientID) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/client/delete/"+clientID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingClient());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(notify({message: l10n.messages.removed, status: 'success'}));
                return response;
            })
            .then(() => {
                dispatch(doneDeletingClient());
                dispatch(fetchClients());
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingClient());
            });
    };
}

export function doneDeletingClient() {
    return {
        type: types.DONE_DELETING_CLIENT
    };
}

export function deletingClient() {
    return {
        type: types.DELETING_CLIENT
    };
}


export function loading() {
    return {
        type: types.LOADING_CLIENT
    };
}


export function saving(client) {
    return {
        type: types.SAVING_CLIENT,
        payload: client
    };
}

export function saved(client) {
    return {
        type: types.SAVED_CLIENT,
        payload: client
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_CLIENTS,
    };
}

export function receiveClients(data) {
    return {
        type: types.RECEIVED_CLIENTS,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}



// WEBPACK FOOTER //
// ./src/actions/client.js